
import Card from "./components/Card/Card";
import './App.css';

function App() {
  return (
    <div className="App">
       <Card />
       <p class="attribution">
      Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">Frontend Mentor</a>. 
      Coded by <a href="#">Your Name Here</a>.
    </p>
    </div>
  );
}

export default App;
